import axios from 'axios'
import _ from 'lodash'
import queryString from 'query-string';

const DASHBOARD_URL = process.env.REACT_APP_DOMAIN
const AUTH_URL = process.env.REACT_APP_SERVER_URL

const doVerify = async (token) => {
  try {
    const loginToken = await axios.get(`${AUTH_URL}/api/firebase/getSFToken`, { headers: { authorization: `Bearer ${token}` } })
    if (!_.isEmpty(loginToken)) { window.location = `${DASHBOARD_URL}/auth/login/${loginToken.data.token}` }
  } catch (err) {
    return err
  }
}

const getCustomToken = async (params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${AUTH_URL}/api/firebase/createCustomTokenForSwitch?${query}`)
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const validateNewAccountSwitchDistributor = async (sendData) => {
  return await axios
  .post(`${AUTH_URL}/api/firebase/validateNewAccountSwitchDistributor`, sendData)
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export {
  doVerify,
  getCustomToken,
  validateNewAccountSwitchDistributor
}